import React from "react";
import dropdownArrowIcon from "../images/icons/dropdown-arrow-icon.svg";
import "./SidebarExpandableNavLabel.css";

/**
 * Canonical expandable-nav label + arrow used by Brand Master Account
 * (User Management / Account) and Brand Manager (Account / User Management).
 * Arrow sits immediately after the label; rotates 180deg when expanded.
 */
export default function SidebarExpandableNavLabel({
  label,
  expanded = false,
  testId,
}) {
  return (
    <div
      className="sidebar-expandable-nav-label"
      data-testid={testId || "sidebar-expandable-nav-label"}
    >
      <span className="sidebar-expandable-nav-label__text">{label}</span>
      <img
        alt=""
        src={dropdownArrowIcon}
        className={`sidebar-dropdown-arrow${expanded ? " expanded" : ""}`}
        data-testid="sidebar-dropdown-arrow"
        data-expanded={expanded ? "true" : "false"}
        aria-hidden="true"
      />
    </div>
  );
}
